import * as R from 'ramda';
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
// helpers/constants
import * as GC from '../../constants';
//////////////////////////////////////////////////

const selectReferenceStore = (state) => state[GC.UI_FIELD_REFERENCE];

const makeSelectReference = () => createSelector(
  selectReferenceStore,
  (reference) => reference,
);

const makeSelectReferenceById = (_, guid) => createSelector(
  selectReferenceStore,
  (reference) => R.path([reference.activeList, 'list', guid], reference)
);

const makeSelectAllReferenceTypesList = () => createSelector(
  selectReferenceStore,
  ({ allReferenceTypesList }) => allReferenceTypesList,
);

const makeSelectAllAvailableReferenceTypesList = () => createSelector(
  selectReferenceStore,
  ({ allAvailableReferenceTypesList }) => allAvailableReferenceTypesList,
);

const makeSelectAllAvailableCloReferenceTypes = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScopeName }) => R.pathOr(
    [],
    [GC.REF_SCOPE_NAME_CLO],
    availableReferenceTypesByScopeName,
  ),
);

const makeSelectAllAvailableCloAndCloInvoiceReferenceTypes = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScopeName }) => R.concat(
    R.pathOr(
      [],
      [GC.REF_SCOPE_NAME_CUSTOMER_INVOICE],
      availableReferenceTypesByScopeName,
    ),
    R.compose(
      R.map(R.assoc(GC.FIELD_REFERENCE_FIELD_NAME, GC.REFERENCE_FIELD_NAME_CLO)),
      R.pathOr([], [GC.REF_SCOPE_NAME_CLO]),
    )(availableReferenceTypesByScopeName),
  ),
);

const makeSelectAllAvailableClosAndTelsReferenceTypes = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScopeName }) => R.concat(
    R.compose(
      R.map(R.assoc(GC.FIELD_REFERENCE_FIELD_NAME, GC.REFERENCE_FIELD_NAME_CLOS)),
      R.pathOr([], [GC.REF_SCOPE_NAME_CLO]),
    )(availableReferenceTypesByScopeName),
    R.compose(
      R.map(R.assoc(GC.FIELD_REFERENCE_FIELD_NAME, GC.REFERENCE_FIELD_NAME_TELS)),
      R.pathOr([], [GC.REF_SCOPE_NAME_TEL]),
    )(availableReferenceTypesByScopeName),
  ),
);

const makeSelectAllAvailableTelReferenceTypes = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScopeName }) => R.pathOr(
    [],
    [GC.REF_SCOPE_NAME_TEL],
    availableReferenceTypesByScopeName,
  ),
);

const makeSelectLoadEventRefTypes = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScopeName }) => R.pathOr(
    [],
    [GC.REF_SCOPE_NAME_LOAD_EVENT],
    availableReferenceTypesByScopeName,
  ),
);

const makeSelectOwnedReferenceTypesList = () => createSelector(
  selectReferenceStore,
  ({ ownedReferenceTypesList }) => ownedReferenceTypesList,
);

const makeSelectReferenceScopes = () => createSelector(
  selectReferenceStore,
  ({ scopes }) => scopes,
);

const makeSelectAvailableReferenceTypesByScope = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScope }) => availableReferenceTypesByScope,
);

const makeSelectScopeByName = createCachedSelector(
    selectReferenceStore,
    (state, name) => name,
    (referenceState, name) => (
      R.find(R.propEq(name, 'name'), referenceState.scopes)
    ),
)(
  (state, name) => name,
);

const makeSelectPagination = () => createSelector(
  selectReferenceStore,
  (state) => R.path([state.activeList, 'pagination'], state),
);

const makeSelectItemList = () => createSelector(
  selectReferenceStore,
  (state) => R.path([state.activeList, 'list'], state),
);

const makeSelectActiveList = () => createSelector(
  selectReferenceStore,
  ({ activeList }) => activeList,
);

const makeSelectItemListSorted = () => createSelector(
  selectReferenceStore,
  (state) => R.sortBy(
    R.prop('index'),
    R.values(R.path([state.activeList, 'list'], state)),
  ),
);

const makeSelectListLoading = () => createSelector(
  selectReferenceStore,
  ({ loading }) => loading,
);

const makeSelectFilterParams = () => createSelector(
  selectReferenceStore,
  ({ filterParams }) => filterParams,
);

const makeSelectFilterProps = () => createSelector(
  selectReferenceStore,
  ({ filterProps }) => filterProps,
);

const makeSelectTotalCount = () => createSelector(
  selectReferenceStore,
  (state) => R.path([state.activeList, 'totalCount'], state),
);

const makeSelectAllAvailableReferenceTypesByScopeName = () => createSelector(
  selectReferenceStore,
  ({ availableReferenceTypesByScopeName }) => availableReferenceTypesByScopeName,
);

export {
  makeSelectItemList,
  makeSelectReference,
  selectReferenceStore,
  makeSelectActiveList,
  makeSelectTotalCount,
  makeSelectPagination,
  makeSelectScopeByName,
  makeSelectListLoading,
  makeSelectFilterProps,
  makeSelectFilterParams,
  makeSelectReferenceById,
  makeSelectItemListSorted,
  makeSelectReferenceScopes,
  makeSelectLoadEventRefTypes,
  makeSelectAllReferenceTypesList,
  makeSelectOwnedReferenceTypesList,
  makeSelectAllAvailableCloReferenceTypes,
  makeSelectAllAvailableTelReferenceTypes,
  makeSelectAvailableReferenceTypesByScope,
  makeSelectAllAvailableReferenceTypesList,
  makeSelectAllAvailableClosAndTelsReferenceTypes,
  makeSelectAllAvailableReferenceTypesByScopeName,
  makeSelectAllAvailableCloAndCloInvoiceReferenceTypes,
};
